export const toggleDisplayOnEmptyCartState = (state, action) => {
  const rows = [...state.loadedPage.cmsContent.rows];
  const currentRow = rows[action.payload.rowIndex];
  const currentValue = currentRow.settings?.displayOnEmptyCart === 'true';

  rows[action.payload.rowIndex] = {
    ...currentRow,
    settings: {
      ...currentRow.settings,
      displayOnEmptyCart: currentValue ? 'false' : 'true',
    },
  };

  return {
    ...state,
    loadedPage: {
      ...state.loadedPage,
      cmsContent: {
        ...state.loadedPage.cmsContent,
        rows,
      },
    },
  };
};
